import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import Link from './Link';
import Image from './Image';

const propTypes = {
    title: PropTypes.string,
    quote: PropTypes.string,
    text: PropTypes.string,
    media: PropTypes.object,
};

const defaultProps = {
    title: 'Title',
    quote: null,
    text: 'Lorem ipsum.....',
    media: {
        url: '/img/placeholders/bigquote.jpg',
    },
};

class Hero extends Component {

    render() {
        const { title, quote, text, media } = this.props;

        return (
            <div className="partial-hero container hero-container relative">
                <div className="col-left">
                    <Image background media={media} />
                </div>
                <div className="col-right">
                    <div className="align-bottom padded">
                        { title !== null ? (
                            <h2 className="title page-title">{title}</h2>
                        ) : null}
                        { quote !== null ? (
                            <p className="text">{`"${quote}"`}</p>
                        ) : null}
                        { text !== null ? (
                            <p className="text">{text}</p>
                        ) : null}
                    </div>
                </div>
                <div className="clearfix" />
            </div>
        );
    }
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;



// WEBPACK FOOTER //
// ./components/partials/Hero.jsx